
export default function Testimonials() {
  const testimonials = [
    {
      name: 'Ryan Bigler',
      title: 'Director of Business Operations',
      company: 'Delaware North at Truist Park',
      image: 'https://static.readdy.ai/image/8a088853fb554840745d180bcc58d87d/1649b67c6d4aab47bf4d50c74af8e96d.jpeg',
      text: 'Working with Trey and Nichole has been an absolute pleasure. Their dedication, professionalism, and attention to detail are unmatched. From our time together at Usana Amphitheater to the State Fair Park and MAVERIK Center, they consistently delivered exceptional results and brought genuine care to every project.',
      rating: 5
    },
    {
      name: 'Agostino DiGiacomo',
      title: 'Business Consultant',
      company: 'Small Business Specialist',
      image: 'https://static.readdy.ai/image/8a088853fb554840745d180bcc58d87d/42ebcdbe0aef2f2ec607efddd5bc3004.jpeg',
      text: 'Trey and Nichole are exceptional partners in business transformation. Traveling the country together, we helped countless small businesses become more organized, financially profitable, and better run. Their commitment to excellence and genuine care for business owners is truly remarkable.',
      rating: 5
    },
    {
      name: 'Jill Roberts',
      title: 'Operations Manager',
      company: 'Diamond Creations Catering',
      image: 'https://static.readdy.ai/image/8a088853fb554840745d180bcc58d87d/c9b870e983e17134999ac1922ab75a3f.jpeg',
      text: 'Nichole brought incredible expertise and vision to our team at Diamond Creations. Her strategic thinking and dedication to excellence helped elevate our catering services to new heights. It was a privilege to work alongside someone so talented and committed.',
      rating: 5
    },
    {
      name: 'Michael Pace',
      title: 'President & Founder',
      company: 'Pace-O-Matic',
      image: 'https://paceomatic.com/wp-content/uploads/2025/01/POMHEADSHOTS_final-7185-1-1024x683.jpg',
      text: 'Trey managed our Chattanooga property with exceptional skill and professionalism. Nichole was instrumental not only in property operations but also in designing our company\'s Integrity Award. Their combined talents and dedication made a lasting impact on our organization.',
      rating: 5
    },
    {
      name: 'Richard Kennedy',
      title: 'CEO/Executive Leadership',
      company: '5 Star Break Time Solutions',
      image: 'https://five-star.transforms.svdcdn.com/production/images/Untitled-design-15.png?w=800&h=800&q=40&auto=format&fit=crop&dm=1746194743&s=28ac9f5672b93d41d20eed85c0a3193f',
      text: 'Nichole was brought in as an outside consultant and became a true pioneer in our organization. She engineered and grew our catering division from the ground up, consistently delighting customers and expanding our business. Her expertise and dedication were invaluable.',
      rating: 5
    },
    {
      name: 'John Fava',
      title: 'Founder & President',
      company: 'Associated Builders',
      image: 'https://static.readdy.ai/image/8a088853fb554840745d180bcc58d87d/2b4ae61303b5ee76ba69fc8b45d1a7d0.png',
      text: 'I\'ve had the pleasure of working closely with Trey for over three years. His hard work, dedication, and genuine commitment to caring for others have been exceptional. Trey brings both expertise and heart to everything he does, making him an invaluable partner.',
      rating: 5
    }
  ];

  return (
    <section id="testimonials" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
            People Say the <strong className="text-[#0F3A2E]">Nicest Things</strong>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Hear from the professionals we've had the privilege of working with over the years
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <article key={index} className="bg-gray-50 rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 rounded-full overflow-hidden mr-4 flex-shrink-0">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-full h-full object-cover object-top"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 text-base">{testimonial.name}</h4>
                  <p className="text-sm text-gray-600">{testimonial.title}</p>
                  <p className="text-xs text-[#0F3A2E] font-semibold">{testimonial.company}</p>
                </div>
              </div>

              <div className="flex mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#C9A24D] text-lg"></i>
                ))}
              </div>

              <p className="text-sm text-gray-700 leading-relaxed">
                "{testimonial.text}"
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
